import { LOCATION_TYPES } from "@/react/components/Events/EditForm/helpers";
import { wasMinutesAgo } from "@/react/helpers/dateTimeHelpers";
import type { Event } from "@/react/types/Event";

export const useLiveStreamIssue = (event: Event) => {
  const { event_setting_attributes: eventData, policies } = event || {};

  const {
    starts_at: startsAt,
    location_type: locationType,
    live_stream_slug: liveStreamSlug,
  } = eventData || {};

  const { can_manage_post: canManagePost, can_update_post: canUpdatePost } =
    policies || {};

  const isStartingIn20Minutes = wasMinutesAgo(startsAt, 20);
  const isLiveEvent = [
    LOCATION_TYPES.LIVE_STREAM,
    LOCATION_TYPES.LIVE_ROOM,
  ].includes(locationType);
  const isCreated = !!liveStreamSlug;

  return {
    hasLiveCreationIssue:
      isStartingIn20Minutes && isLiveEvent && !isCreated && canManagePost,
    canCreateLive: canManagePost || canUpdatePost,
  };
};
